import React from 'react';
import './Logo.css';

const Logo = ({ className = '', onClick }) => {
  // Determine the correct path for the logo
  // In production with nginx, it's served under /admin/ (see nginx.conf)
  // In development, it's at the root
  const logoPath = process.env.NODE_ENV === 'production' 
    ? '/admin/logo.png' 
    : '/logo.png';
    
  return (
    <div className={`logo-container ${className}`} onClick={onClick} style={{ cursor: onClick ? 'pointer' : 'default' }}>
      <img 
        src={logoPath}
        alt="Skylight Logo"
        className="logo-image"
      />
    </div>
  );
};

export default Logo; 